
import { Grid, IconButton } from '@material-ui/core';
import api, { ConvocadosResponse } from 'api/Assessor/convocados';
import AssembeliaDateTime from 'components/AssembleiaDateTime';
import BreadCrumb from 'components/BreadCrumb/BreadCrumb';
import { IBreadCrumbItem } from 'components/BreadCrumb/BreadCrumbItem';
import { BackIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import Loading from 'components/Loading';
import PageTitle from 'components/PageTitle/PageTitle';
import Page from 'components/PrivateContainer';
import { ITopBarMenuItem } from 'components/TopBar/TopBarMenuItem';
import UnauthorizedScreen from 'components/UnauthorizedScreen/UnauthorizedScreen';
import { parseISO } from 'date-fns';
import { TopBarMenuAcessoRapido } from 'enuns/TopBarMenuAcessoRapido';
import { AssembleiaAssessorRoutePath, AssessorRoutePath, MainAssessorRoutePath } from 'library/Routes';
// import PresencasResponse from 'models/PresencasResponse';
import TotalizadoresConvocadosResponse from 'models/TotalizadoresConvocadosResponse';
import React, { useCallback, useContext, useEffect, useMemo, useReducer, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { assembleiasAssessorActionsAtualizarPresencasConvocados, assembleiasAssessorLoadEvento } from 'store/modules/AssembleiasAssessorActions';
import { IAssembleiasAssessorEvent } from 'store/modules/AssembleiasAssessorReducer';
import { IReducer } from 'store/Reducer';
import { wsStartStop } from 'utils/AssembleiaUtils';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import DownloadTrigger from 'utils/DownloadTrigger';
import ErrorHandler from 'utils/ErrorHandler';
import { getToastError } from 'utils/ToasterUtils';
import { getAcessoRapido } from 'utils/TopBarMenuUtils';
import Context, { IConvocadosAssessorContext } from './Context';
import Filtros from './Filtros';
import { relatorioInitialState, relatorioReducer } from './reducer';
import useStyles from './style';
import Tabela from './Tabela';
import Totais from './Totais';

interface RouteParams {
  id: string;
}

export default () => {
  const {t} = useTranslation();
  const {id} = useParams<RouteParams>();
  const location = useLocation();
  const { usuario } = useSelector((state: IReducer) => state.auth);
  const { assembleiasAssessor } = useSelector((state: IReducer) => state);
  const { opened: wsOpened } = useSelector((state: IReducer) => state.wsAssembleias);
  const { setPageMenuItems } = useContext(LayoutContext);
  const reduxDispatch = useDispatch();
  const [state, dispatch] = useReducer(relatorioReducer, relatorioInitialState);
  const [relatorio, setRelatorio] = useState<ConvocadosResponse>();
  const classes = useStyles();
  const history = useHistory();
  const [downloading, setDownloading] = useState<boolean>();
  const [atualizandoPresencas, setAtualizarPresencas] = useState<boolean>(false);
  const [atualizacoesPresenca, setAtualizacoesPresenca] = useState<number>(0);
  const [initialized, setInitialized] = useState<boolean>();
  // const [presencas, setPresencas] = useState<PresencasResponse>();
  const [totalizadores, setTotalizadores ] = useState<TotalizadoresConvocadosResponse>();
  //assembleiasAssessorActionsAtualizarPresencasConvocados
  const [cooperativas, setCooperativas] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>();

  const currEvento = useMemo<IAssembleiasAssessorEvent | null>(() => {
    if (assembleiasAssessor?.evento?.id && assembleiasAssessor?.evento?.id.toString() === id) {
      return assembleiasAssessor.evento;
    }
    return null;
  }, [assembleiasAssessor, id])

  const loadingEvento = useMemo<boolean>(() => {
    return !!assembleiasAssessor?.loadingEvento
  }, [assembleiasAssessor])

  const loadingListaEvento = useMemo<boolean>(() => {
    return !!assembleiasAssessor?.loadingListaEvento
  }, [assembleiasAssessor])

  const downloadRelatorio = useCallback(() => {
    setDownloading(true);
    api.relatorio({
      ...state,
      idAssembleia: parseInt(id),
    }).then(
      response => {
        setDownloading(false);
        if (response.data) {
          DownloadTrigger(`Relatorio_Convocados_${id}.xls`, response.data as ArrayBuffer);
        } else {
          getToastError(t(`DownloadErrorMessages.relatorioConvocados`));
        }
      },
      error => {
        setDownloading(false);
        ErrorHandler(error);
      }
    )
  }, [id, state, t])
  
  const subMenu = useMemo<ITopBarMenuItem[]>(() => {
    if (usuario) {
      const menus: ITopBarMenuItem[] = getAcessoRapido(t, usuario.perfil, TopBarMenuAcessoRapido.Convocados, id);

      if (typeof relatorio?.totalElements === 'number' && relatorio.totalElements > 0) {
        menus.push({
          label: t(`SubMenus.baixarRelatorio`),
          onClick: downloadRelatorio,
          disabled: loading || downloading
        });
      }

      return menus;
    }

    return [];

  }, [t, usuario, id, loading, downloadRelatorio, downloading, relatorio])

  const eventoNome = useMemo<string | undefined>(() => {
    return currEvento?.nome;
  }, [currEvento])

  const breadcrumb = useMemo((): IBreadCrumbItem[] => {
    if (eventoNome) {
      return [
        {
          nome: t('MainRoute.title'),
          url: MainAssessorRoutePath,
        },
        {
          nome: eventoNome,
          url: AssembleiaAssessorRoutePath.replace(':id', `${id}`),
        },
        {
          nome: t('ConvocadosAssessor.title'),
        },
      ];
    }
    return [];
  }, [t, eventoNome, id]);

  const hasPermission = useCallback((): boolean => {
    if (usuario) {
      return usuario.perfil.assessorRoute.convocados.view;
    }
    return false;
  }, [usuario])

  // const atualizarPresencas = useCallback(async () => {
  //   if (!currEvento?.id || currEvento.id !== parseInt(id)) return;
  //   setAtualizacoesPresenca(atualizacoesPresenca + 1);
  //   setAtualizarPresencas(true);
  //   reduxDispatch(
  //     assembleiasAssessorActionsAtualizarPresencas(
  //       currEvento.id,
  //       data => {
  //         setPresencas(data);
  //         setAtualizarPresencas(false);
  //       },
  //       fail => {
  //         ErrorHandler(fail);
  //         setAtualizarPresencas(false);
  //       }
  //     )
  //   );
  // }, [reduxDispatch, currEvento, setAtualizarPresencas, id, setAtualizacoesPresenca, atualizacoesPresenca]);

  const atualizarPresencas = useCallback(async () => {
    if (!currEvento?.id || currEvento.id !== parseInt(id)) return;
    setAtualizacoesPresenca(atualizacoesPresenca + 1);
    setAtualizarPresencas(true);
    reduxDispatch(
      assembleiasAssessorActionsAtualizarPresencasConvocados(
        currEvento.id,
        data => {
          setTotalizadores(data);
          setAtualizarPresencas(false);
        },
        fail => {
          ErrorHandler(fail);
          setAtualizarPresencas(false);
        }
      )
    );
  }, [reduxDispatch, currEvento, setAtualizarPresencas, id, setAtualizacoesPresenca, atualizacoesPresenca, setTotalizadores]);

  useEffect(() => {
    if (atualizacoesPresenca === 0 && !atualizandoPresencas) {
      atualizarPresencas();
    }
  }, [atualizarPresencas, atualizacoesPresenca, atualizandoPresencas])

  const backToEvent = useCallback(() => {
    if (!currEvento) return;
    history.push(AssembleiaAssessorRoutePath.replace(':id', `${currEvento.id}`));
  }, [currEvento, history]);

  const needLoadEvento = useMemo(() => {
    if (loadingListaEvento || loadingEvento) return false;
    if (!currEvento) return true;
    if (currEvento.id !== parseInt(id)) return true;
    return false;
  }, [currEvento, id, loadingEvento, loadingListaEvento]);

  useEffect(() => {
    setPageMenuItems(subMenu);
    return () => setPageMenuItems();
  }, [subMenu, setPageMenuItems]);

  useEffect(() => {
    if (usuario) {
      wsStartStop(
        usuario,
        Number(id),
        reduxDispatch,
        wsOpened
      )
    }
  }, [usuario, location, id, reduxDispatch, wsOpened])
  
  useEffect(() => {
    if (needLoadEvento && !initialized) {
      setInitialized(true);
      reduxDispatch(
        assembleiasAssessorLoadEvento(
          parseInt(id),
          () => {setInitialized(false)},
          error => {
            AxiosErrorHandler(error);
            if (error.response?.status === 417) {
              history.push(AssessorRoutePath);
            }
          }
        )
      );
    }
  }, [needLoadEvento, reduxDispatch, id, history, initialized, setInitialized]);

  useEffect(() => {
    const getRelatorio = async () => {
      const { fail, data } = await api.list({
        ...state,
        idAssembleia: parseInt(id),
      });
      if (fail) {
        ErrorHandler(fail);
      }
      if (data) {
        setRelatorio(data);
      }
    };
    const getCooperativas = async () => {
      const { fail, data } = await api.cooperativas(parseInt(id));
      if (fail) {
        ErrorHandler(fail);
      }
      if (data) {
        setCooperativas(data);
      }
    };
    if (!needLoadEvento) {
      setLoading(true);
      getRelatorio().then(() => setLoading(false), () => setLoading(false));
      getCooperativas();
    }
  }, [needLoadEvento, id, state, setLoading]);

  const contextValues = useMemo<IConvocadosAssessorContext>((): IConvocadosAssessorContext => {
    return {
      presencas: null,
      atualizarPresencas,
      atualizandoPresencas,
    }
  }, [atualizarPresencas, atualizandoPresencas])

  if (currEvento && loadingEvento) {
    return (
      <Page>
        <Loading />
      </Page>
    );
  }

  if (!hasPermission()) {
    return <UnauthorizedScreen />;
  }

  return currEvento && (
    <Context.Provider value={contextValues}>
      <Page
        headerClassName={classes.header}
        header={
          <React.Fragment>
            <div className={classes.headline}>
              <IconButton onClick={backToEvent} className={classes.backButton}>
                <BackIcon />
              </IconButton>
              <PageTitle title={t('ConvocadosAssessor.title')} />
            </div>
            <div className={classes.info}>
              <BreadCrumb itens={breadcrumb!} />
              <AssembeliaDateTime date={parseISO(currEvento.dataEvento)} dateFim={parseISO(currEvento.dataEventoFim)} />
            </div>
          </React.Fragment>
        }
      >
        <Grid container spacing={3} justify="space-between">
          <Grid item xs={12}>
            {/* <Totais className={classes.totais} colaboradores={presencas?.colaboradoresPresentes || 0} presentes={presencas?.presentes || 0} /> */}
            <Totais className={classes.totais} colaboradores={totalizadores?.totalColaboradores || 0} presentes={totalizadores?.totalConvocados || 0} />
          </Grid>
        </Grid>
        <Filtros
          listaCoops={cooperativas}
          onChangeFilter={value => {
            dispatch({ type: 'setFiltros', value });
          }}
        />
        {relatorio && !downloading && (
          <Tabela
            relatorio={relatorio}
            page={state.page}
            size={state.size}
            onChangePage={page =>
              dispatch({
                type: 'setPaginacao',
                value: { page },
              })
            }
            onChangeSize={(size, page) =>
              dispatch({
                type: 'setPaginacao',
                value: { size, page },
              })
            }
          />
        )}
        {(!!loading || !!downloading) && <Loading />}
      </Page>
    </Context.Provider>
  )
}